export default class TranscriptCourseStatusDomainService {
    static get Registered() {
        return {
            id: TranscriptCourseStatusDomainService.RegisteredId,
            description: "Registered",
            integrationId: "REGISTERED",
        };
    }
    static get DroppedId() {
        return "75065394-431d-4f55-99b1-aae05cd4007c";
    }
    static get RegisteredId() {
        return "b2d58f2a-6dcd-4fe1-91a9-07d44eee8d4c";
    }
    static get PurgedByInstitutionId() {
        return "03f4bb98-93ce-4b95-b91e-facec5cd6b59";
    }
    static get WaitlistId() {
        return "23cc03e4-c66e-4710-bd1c-d5cd5fa2944f";
    }
    static get WithdrawInProgressId() {
        return "8d58ff78-4604-4e23-9d36-f471c9ed8565";
    }
    static get WithdrawnId() {
        return "4e566651-6872-41d6-bcef-6dd3a683d91b";
    }
    static get UnknownId() {
        return "3beb5560-45dd-4d6a-9117-5bc830ef4854";
    }
    static get DeletedId() {
        return "c5039250-c95b-11e2-ac6d-08606e871df1";
    }
    static get WebwithdrawnId() {
        return "01671761-38c0-485c-bcc2-5de6e5c2013b";
    }
}
